window.MapManager = class {
    customFeatures = {};
    mapOptions = {};
    map = null;
    container = null;
    marker = null;

    constructor(mapOptions, shelves) {
        this.mapOptions = mapOptions;
        this.initiateMap();

        // Add zoom and rotation controls to the map.
        this.map.addControl(new Mazemap.mapboxgl.NavigationControl());

        // Add custom layers, custom features and redraw polygons on load.
        this.map.on('load', () => {
            this.setupShelves(shelves);
            const event = new Event("mapHasLoaded");
            document.body.dispatchEvent(event);
        });

        // Redraw custom features on map when floor changes.
        this.map.on('zlevel', () => this.redrawPolygons());
    }

    initiateMap() {
        this.map = new Mazemap.Map(this.mapOptions);
    }

    setupShelves(shelves) {
        Object.keys(shelves).forEach(layerId => {
            this.addMapLayer({
                name: layerId,
                color: shelves[layerId]['color'],
            });

            this.addCustomFeature(shelves[layerId], layerId);

        });

        this.redrawPolygons()
    }

    clearMap() {
        this.map = null;
        delete this.map;
        document.getElementById(this.mapOptions.container).textContent = '';
    }

    redrawPolygons() {
        var zLevel = this.map.getZLevel();

        Object.keys(this.customFeatures).forEach(key => {
            var filteredFeatures = this.customFeatures[key].filter(
                feature => feature.properties.zLevel === zLevel && feature.properties.visibility === 'visible'
            );
            this.map.getSource(key).setData({type: "FeatureCollection", features: filteredFeatures});
        });
    }

    addBlueDot(poi) {
        this.map.setCenter([[poi['lng']], [poi['lat']]]);

        // Just for visual effect, wait a bit before adding to map and zooming in.
        setTimeout(() => {
            this.placePoiMarker(poi);

            if (poi.text !== null) {
                this.addTextLayer(poi);
            }
        }, 1000);
    }

    placePoiMarker(poi) {
        const blueDot = new Mazemap.BlueDot({
            map: this.map,
        })
        .setLngLat({lng: poi['lng'], lat: poi['lat']})
        .setZLevel(poi['zLevel'])
        .setAccuracy(5)
        .show();

        this.map.flyTo({
            center: {
                lng: [poi['lng']],
                lat: [poi['lat']]
            },
            zoom: 19, // Should read from collection.zoom_level
            speed: 0.5
        });
    }

    placeMarker(coordinates, zLevel) {
        // Remove previous marker if set.
        if (this.marker !== null) {
            this.marker.remove();
        }

        this.marker = new Mazemap.MazeMarker( {
            zLevel: zLevel
        })
        .setLngLat(coordinates)
        .addTo(this.map);
    }

    addMapLayer(layer) {
        this.map.addLayer({
            id: layer.name,
            type: "fill",
            source: {
                type: 'geojson',
                data: null,
            },
            paint: {
                "fill-color": layer.color,
                "fill-outline-color": "#000"
            }
        });
    }

    getLayerInfo(layerId) {
        return this.customFeatures[layerId][0];
    }

    addCustomFeature(shelf, layerId) {
        this.customFeatures[layerId] = [];

        if (shelf.hasOwnProperty('coordinates')) {
            this.customFeatures[layerId].push(
                {
                    type: "Feature",
                    properties: {
                        zLevel: shelf.zLevel,
                        name: shelf.name,
                        visibility: shelf.visibility,
                    },
                    geometry: {
                        approximatedCenter: this.approximateCenter(shelf.coordinates),
                        type: "Polygon",
                        coordinates: [
                            shelf.coordinates
                        ]
                    }
                }
            );
        }
    }

    setCustomFeatures(o) {
        this.customFeatures = o;
    }

    approximateCenter(coordinates) {
        let minMaxValues = {
            'lng': {
                'min': coordinates[0][0],
                'max': coordinates[0][0]
            },
            'lat': {
                'min': coordinates[0][1],
                'max': coordinates[0][1]
            }
        };

        coordinates.forEach(c => {
            if (c[0] < minMaxValues['lng']['min']) {
                minMaxValues['lng']['min'] = c[0];
            }
            if (c[0] > minMaxValues['lng']['max']) {
                minMaxValues['lng']['max'] = c[0];
            }
            if (c[1] < minMaxValues['lat']['min']) {
                minMaxValues['lat']['min'] = c[1];
            }
            if (c[1] > minMaxValues['lat']['max']) {
                minMaxValues['lat']['max'] = c[1];
            }
        });

        return {
            'lng': (minMaxValues['lng']['min'] + minMaxValues['lng']['max']) / 2,
            'lat': (minMaxValues['lat']['min'] + minMaxValues['lat']['max']) / 2
        };
    }

    addTextLayer(poi) {
        this.map.addSource('custom-text', {
            'type': 'geojson',
            'data': {
                type: "FeatureCollection",
                features: [
                    {
                        type: "Feature",
                        properties: {
                            text: poi.text,
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                poi['lng'],
                                poi['lat'],
                            ],
                        },
                    }
                ],
            },
        });

        this.map.addLayer({
            'id': 'custom-text-layer',
            'type': 'symbol',
            'source': 'custom-text',
            'layout': {
                'text-field': ['get', 'text'],
                'text-size': 15,
                'text-offset': [0, 0],
            },
            'paint': {
                'text-color': '#000',
            }
        });
    }
}
